// Defensive JSON helpers for shared/storage.
// Returning fallbacks (instead of throwing) keeps render code free of try/catch.

export function safeParseJson<T>(raw: string | null | undefined, fallback: T): T {
  if (raw === null || raw === undefined) {
    return fallback;
  }
  try {
    return JSON.parse(raw) as T;
  } catch {
    // Malformed JSON in storage is recoverable: callers get the fallback
    // and the bad value will be overwritten on the next set().
    return fallback;
  }
}

export function safeStringify(value: unknown): string | null {
  try {
    return JSON.stringify(value);
  } catch {
    // Circular references and BigInts throw. Returning null lets the caller
    // skip writing rather than corrupting storage.
    return null;
  }
}
